import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ListboxModule } from "primeng/listbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { ButtonModule } from "../shared/button/button.module";
import { IconModule } from "../shared/icon/icon.module";
import { PanelModule } from "../shared/panel/panel.module";
import { FactoryComponent } from "./factory/factory.component";
import { AutocompleteComponent } from "./inputs/autocomplete/autocomplete.component";
import { CalenderComponent } from "./inputs/calender/calender.component";
import { CheckboxGroupModule } from "./inputs/checkbox-group/checkbox-group.module";
import { CheckboxComponent } from "./inputs/checkbox/checkbox.component";
import { ChipAutocompleteComponent } from "./inputs/chip-autocomplete/chip-autocomplete.component";
import { ConfirmAutocompleteComponent } from "./inputs/confirm-autocomplete/confirm-autocomplete.component";
import { ConfirmNoPageNumberComponent } from "./inputs/confirm-no-page-number/confirm-no-page-number.component";
import { ConfirmProviderComponent } from "./inputs/confirm-provider/confirm-provider.component";
import { ConfirmComponent } from "./inputs/confirm/confirm.component";
import { DropdownComponent } from "./inputs/dropdown/dropdown.component";
import { ProviderDropdownComponent } from "./inputs/provider-dropdown/provider-dropdown.component";
import { RadiobuttonComponent } from "./inputs/radiobutton/radiobutton.component";
import { SwitchComponent } from "./inputs/switch/switch.component";
import { TextareaComponent } from "./inputs/textarea/textarea.component";
import { TextboxModule } from "./inputs/textbox/textbox.module";
import { VrcDropdownComponent } from "./inputs/vrc-dropdown/vrc-dropdown.component";
import { DateBetweenValidatorDirective } from "./validators/date-between.validator";
import { EnabledOptionsOnlyValidatorDirective } from "./validators/enabled-options-only.validator";

@NgModule({
  imports: [
    CommonModule,
    CheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    InputTextareaModule,
    AutoCompleteModule,
    ListboxModule,
    ButtonModule,
    RadioButtonModule,
    IconModule,
    DropdownModule,
    InputSwitchModule,
    PanelModule,
    TextboxModule,
    CheckboxGroupModule,
    CalendarModule,
  ],
  declarations: [
    FactoryComponent,
    CheckboxComponent,
    AutocompleteComponent,
    TextareaComponent,
    RadiobuttonComponent,
    SwitchComponent,
    DropdownComponent,
    EnabledOptionsOnlyValidatorDirective,
    DateBetweenValidatorDirective,
    VrcDropdownComponent,
    ConfirmComponent,
    ConfirmAutocompleteComponent,
    ConfirmProviderComponent,
    ProviderDropdownComponent,
    ConfirmNoPageNumberComponent,
    CalenderComponent,
    ChipAutocompleteComponent,
  ],
  entryComponents: [
    CheckboxComponent,
    AutocompleteComponent,
    TextareaComponent,
    RadiobuttonComponent,
    SwitchComponent,
    DropdownComponent,
    VrcDropdownComponent,
    ConfirmComponent,
    ConfirmAutocompleteComponent,
    ConfirmNoPageNumberComponent,
    ConfirmProviderComponent,
    ProviderDropdownComponent,
    CalenderComponent,
    ChipAutocompleteComponent,
  ],
  exports: [
    ReactiveFormsModule,
    FactoryComponent,
    EnabledOptionsOnlyValidatorDirective,
    DateBetweenValidatorDirective,
  ],
  providers: [
  ],
})
export class DynamicFormsModule { }
